const animations = {
	el: {

	},

	init () {
		AOS.init({
			disable: 'mobile'
		})
	}
}

animations.init()